import {
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

interface DeleteIndividualLinkRequest {
  hash: string;
  fileId: number;
}

export const deleteIndividualLink = ({
  fileId,
  hash,
}: DeleteIndividualLinkRequest) => {
  return api.delete<ApiResponse>('/v2/file/individual', {
    params: {
      fileId,
      hash,
    },
  });
};

const useDeleteIndividualLink = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse>,
    TError,
    DeleteIndividualLinkRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse>,
  TError,
  DeleteIndividualLinkRequest,
  QueryKey
> => {
  return useMutation(deleteIndividualLink, {
    ...options,
  });
};

export default useDeleteIndividualLink;
